import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Play } from 'lucide-react';
import { LeadForm } from './LeadForm';
export function Hero() {
  return <section id="book-call" className="relative min-h-screen flex items-center pt-24 pb-12 md:pt-32 md:pb-20 overflow-hidden" data-id="element-81">
      {/* Background Elements */}
      <div className="absolute inset-0 z-0" data-id="element-82">
        <div className="absolute top-[-10%] right-[-10%] w-[500px] h-[500px] bg-brand-accent/5 rounded-full blur-[120px]" data-id="element-83" />
        <div className="absolute bottom-[-10%] left-[-10%] w-[400px] h-[400px] bg-blue-500/5 rounded-full blur-[100px]" data-id="element-84" />
        <div className="absolute inset-0 opacity-20 bg-[url('https://images.unsplash.com/photo-1557804506-669a67965ba0?auto=format&fit=crop&q=80')] bg-cover bg-center mix-blend-overlay" data-id="element-85" />
      </div>

      <div className="container mx-auto px-4 sm:px-6 relative z-10" data-id="element-86">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-87">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-88">
            <span className="inline-block py-1 px-3 rounded-full bg-brand-accent/10 border border-brand-accent/20 text-brand-accent text-[10px] sm:text-xs font-bold tracking-widest uppercase mb-4 sm:mb-6" data-id="element-89">
              Next-Gen Operational Partner
            </span>
            <h1 className="text-4xl sm:text-5xl md:text-7xl font-serif font-bold text-white leading-[1.1] mb-6 sm:mb-8" data-id="element-90">
              Scale Your Operations <br data-id="element-91" />
              <span className="text-brand-accent" data-id="element-92">
                Without Scaling Your Team
              </span>
            </h1>
            <p className="text-base sm:text-lg md:text-xl text-slate-400 leading-relaxed max-w-2xl mb-8 sm:mb-10" data-id="element-93">
              Deskmayte acts as your operational extension — managing customer
              acquisition, staffing, lead generation, outreach, and marketing
              while your team focuses on growth.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4" data-id="element-94">
              <button className="w-full sm:w-auto bg-brand-accent text-brand-dark px-6 py-3.5 sm:px-8 sm:py-4 rounded-xl font-bold text-base sm:text-lg flex items-center justify-center gap-2 hover:bg-white transition-all group" data-id="element-95">
                Book Discovery Call
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-96" />
              </button>
              <button className="w-full sm:w-auto bg-white/5 border border-white/10 px-6 py-3.5 sm:px-8 sm:py-4 rounded-xl font-bold text-base sm:text-lg flex items-center justify-center gap-2 hover:bg-white/10 transition-all" data-id="element-97">
                <Play className="w-5 h-5 fill-current" data-id="element-98" />
                Explore Services
              </button>
            </div>
          </motion.div>

          <div className="flex w-full justify-center lg:justify-end mt-8 lg:mt-0" data-id="element-99">
            <LeadForm data-id="element-100" />
          </div>
        </div>

        {/* Trust Badges */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.5,
        duration: 1
      }} className="mt-12 sm:mt-20 pt-8 sm:pt-10 border-t border-white/5 flex flex-wrap justify-center lg:justify-start items-center gap-6 sm:gap-12 opacity-50 grayscale hover:grayscale-0 transition-all" data-id="element-101">
          <span className="text-xs sm:text-sm font-semibold uppercase tracking-widest text-center w-full lg:w-auto" data-id="element-102">
            Trusted by industry leaders
          </span>
          <div className="flex flex-wrap justify-center gap-6 sm:gap-8 items-center" data-id="element-103">
            <div className="text-lg sm:text-xl font-bold" data-id="element-104">FORBES</div>
            <div className="text-lg sm:text-xl font-bold" data-id="element-105">TECHCRUNCH</div>
            <div className="text-lg sm:text-xl font-bold" data-id="element-106">BLOOMBERG</div>
            <div className="text-lg sm:text-xl font-bold" data-id="element-107">WIRED</div>
          </div>
        </motion.div>
      </div>
    </section>;
}